import { apiService } from '../../../../services/apiService';

/**
 * Wraps the EXISTING /admin/jobseekers endpoint (JobseekerController::index)
 * — used elsewhere for the jobseeker table and the Lane/Kanban view — so the
 * Jobseekers Report's drill-down lists ("who's in this stage/visa/manager")
 * show real matching jobseekers without re-implementing any of that
 * filtering/grouping logic here.
 */

/**
 * Lane view: returns { success, view: 'lane', group_by, columns: [{ group_id,
 * title, total, page, has_more, lane_type, data: [...] }] }. Every lane
 * comes back in one payload — pick out the lane whose group_id/title
 * matches the stage or sub-stage name you clicked.
 *
 * @param {'stage'|'sub_stage'} groupBy
 * @param {Object} easyFilters e.g. { onboarding_hold, training_status }
 * @param {Object} [columnPage] e.g. { 'Placement Onboarding': 2 } for "load more" on one lane
 */
export const fetchJobseekerLanes = (groupBy, easyFilters = {}, columnPage = null) => {
    const params = {
        view: 'lane',
        group_by: groupBy,
        per_page: 8,
        ...easyFilters,
    };
    if (columnPage) params.column_page = columnPage;
    return apiService.postRequest('/admin/jobseekers', params);
};

/**
 * Table view: returns a JobseekerResource-shaped paginated list. Used for
 * the visa/manager drill-down lists, whose breakdown values map cleanly onto
 * JobseekerFilterService's existing advanced-filter columns.
 *
 * @param {Array} filters advanced-filter objects: [{ column, operator, value? }]
 * @param {Object} easyFilters e.g. { onboarding_hold, training_status }
 * @param {number} perPage
 * @param {number} [page]
 */
export const fetchJobseekerTableRows = (filters, easyFilters = {}, perPage = 8, page = 1) => {
    return apiService.postRequest('/admin/jobseekers', {
        per_page: perPage,
        page,
        filters,
        ...easyFilters,
    });
};
